module.exports = __webpack_public_path__ + "img/bg-2.6f7f021a.png";